import { getAuth } from 'firebase/auth';
import { gql, GraphQLClient } from 'graphql-request';

const graphQLClient = new GraphQLClient(`${import.meta.env.VITE_HASURA_ENDPOINT}`);

const createHeader = async () => {
	const auth = getAuth();
	const token = await auth.currentUser?.getIdToken();
	graphQLClient.setHeader('authorization', `Bearer ${token}`);
	graphQLClient.setHeader('x-hasura-role', 'admin');
	return {
		Authorization: `Bearer ${token}`,
	};
};

const ALL_COURSES = gql`
	query AllCourses {
		courses(order_by: { course_name: asc }) {
			course_name
			course_id
			course_division
			is_saved_draft
			is_archived
			submission {
				admin_approval
				dept_approval
			}
			courses_discipline {
				discipline {
					name
				}
			}
			courses_division {
				division {
					name
				}
			}
			courses_users {
				user_id
				course_id
				user {
					user_id
					user_first
					user_last
					dept_chair {
						user_id
					}
				}
			}
		}
	}
`;

export const getAllCourses = async (): Promise<Course[]> => {
	await createHeader();
	const data = await graphQLClient.request(ALL_COURSES);

	return data.courses;
};
